import { render, staticRenderFns } from "./RightFixedPanel.vue?vue&type=template&id=e070619e&scoped=true"
import script from "./RightFixedPanel.vue?vue&type=script&lang=js"
export * from "./RightFixedPanel.vue?vue&type=script&lang=js"
import style0 from "./RightFixedPanel.vue?vue&type=style&index=0&id=e070619e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_css-loader@6.11.0_webpack@5.105.4__lodash@4.18.1__yidcnbbritke6h73lk2rhpn7vi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e070619e",
  null
  
)

export default component.exports